<div>

  <!-- Search -->
  <div class="section-search">
    <div class="container g-5">
      <div class="row">
        <div class="col">
          <app-room-list-search/>
        </div>
      </div>
    </div>
  </div>

  <!-- Filters -->
  <div class="section-filters">
    <div class="container g-5">
      <div class="row">
        <div class="col">
          <app-room-list-filter/>
        </div>
      </div>
    </div>
  </div>

  <!-- Filter banner -->
  <div class="section-filters-results" *ngIf="isFilterGeolocation || isFilterReservation">
    <div class="filtered-bar">
      <div class="text-center">
        <a class="font-white" (click)="clearFilters()">
          <small>
            <span *ngIf="rooms.length === 0">No conference rooms found</span>
            <span *ngIf="rooms.length > 0">
              <span>Showing {{ rooms.length }} conference rooms</span>
              <span *ngIf="isFilterReservation"> on {{ reserve | date: 'shortDate' }} at {{ reserve | date: 'shortTime' }} ({{reserveDuration! * 60 * 60 * 1000 | prettyTime}}) for {{ reservePeople }} people</span>
              <span *ngIf="isFilterGeolocation"> based on search location</span>
            </span>
            <span> (Reset filters)</span>
          </small>
        </a>
      </div>
    </div>
  </div>

  <!-- Room list -->
  <div class="section-places" *ngIf="!loading && isRoomsLoaded && rooms.length > 0">
    <div class="container g-5">
      <div class="row">

        <!-- Room box-->
        <div class="col-12 col-sm-6 col-md-4 col-lg-6 col-xl-6 col-xxl-4" *ngFor="let room of rooms">
          <app-room-box [room]="room" [showPlaceNameAndNeighborhoodText]="true" [showCapacityAndPriceText]="false"/>
          <br/>
        </div>

      </div>
    </div>
  </div>

  <!-- Rooms empty -->
  <div class="section-places-empty" *ngIf="!loading && isRoomsLoaded && rooms.length === 0">
    <div class="container g-5">
      <div class="row">
        <div class="col">
          <app-room-list-empty/>
        </div>
      </div>
    </div>
  </div>

  <br/>

  <!-- Neighborhoods -->
  <div class="section-neighborhoods" *ngIf="!loading && isRegionLoaded && isRoomsLoaded && region && rooms.length > 0">
    <div class="container">
      <div class="row">
        <div class="col">
          <app-room-list-detail [region]="region" [place]="place"/>
        </div>
      </div>
    </div>
  </div>

  <!-- Loading -->
  <div class="container-fluid" *ngIf="loading">
    <div class="text-center">
      <br/>
      <br/>
      <span class="spinner-border"></span>
      <br/>
      <br/>
    </div>
  </div>

</div>
